<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" class="entry-form">
  <ng-container *ngIf="processShellService.processCode==='INTRACSEND'|| processShellService.processCode==='INTRACREQUEST'">
    <app-interac-content></app-interac-content>
  </ng-container>
  <!-- <button class="add-beneficiary" (click)="manageBeneFormHelper.addBene()">Add beneficiary</button> -->
  <box>
    <div class="add-btn-container" style="display:none;"(click)="manageBeneFormHelper.addBene()">
      <span class="add-btn">
        <button type="button" clickable    >
          <svg xmlns="http://www.w3.org/2000/svg" width="14.971" height="14.969" viewBox="0 0 24.971 24.969">
            <g id="Group_10713" data-name="Group 10713" transform="translate(-4351.854 3678.479) rotate(-45)">
              <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)" fill="none"
              stroke="var(--primary-color)" stroke-linecap="round" stroke-width="4" />
              <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)" fill="none"
              stroke="var(--primary-color)" stroke-linecap="round" stroke-width="4" />
            </g>
            </svg>
        </button>
      </span>
    </div>
    <div class="bene-filter">
      <app-bene-filterradio-control
      class="col-xs-12"
      formControlName="beneFilterRadio"
    ></app-bene-filterradio-control>
    </div>
  </box>
  <box >
    <!-- <app-bene-list-display-grid [refreshCriteria$]="state.refreshCriteria$"></app-bene-list-display-grid> -->
    <app-beneficiaries-list-display-grid  [refreshCriteria$]="state.refreshCriteria$"></app-beneficiaries-list-display-grid>
  </box>


  <!-- <app-bene-list-control  class="col-xs-12"
  formControlName="beneList"
  ></app-bene-list-control> -->
</form>
